module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-9.ae13fc22.jpg";